import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { ReportEmailExcel } from 'services/fund'

export default function useSetEmail(onHide: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IFacilitiesReportExcelEmail) => {
            return ReportEmailExcel(payload)
        },
        onSuccess: (_, variables) => {
            toast.success('گزارش برایتان با موفقیت ایمیل شد')
            onHide()
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return {
        mutate,
    }
}
